import { Component, ElementRef, Input, TemplateRef, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from '../../message.service';
import { DocViewerConfig } from 'src/app/support/models/doc-viewer-config.model';
import { WebViewerComponent } from '../../webviewer/webviewer.component';
import { SessionTimeoutService } from 'src/app/session-timeout-dialog/session-timeout.service';

@Component({
  selector: 'app-document-viewer',
  templateUrl: './document-viewer.component.html',
})
export class DocumentViewerComponent implements OnChanges {

  constructor(
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    public message: messageService,
    private readonly sessionTimeoutService: SessionTimeoutService,
  ) { }

  @Input() docViewer!: DocViewerConfig;
  @Input() isFromOnlyPreview: boolean = true;

  isProcessing = true;

  // prevents double popup opening
  private hasOpened = false;

  @ViewChild('viewPopup', { static: true }) viewPopup!: TemplateRef<any>;
  visibleViewPopup!: MatDialogRef<TemplateRef<any>>;

  @ViewChild('webViewerComp', { static: false })
  webViewerComp!: WebViewerComponent;

  // automatically open when docViewer changes
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['docViewer'] && this.docViewer) {
      // open only once
      Promise.resolve().then(() => this.openPopUp());
    }
  }

  openPopUp() {
    if (this.hasOpened) return;         // <-- Block duplicate opens
    this.hasOpened = true;

    this.visibleViewPopup = this.dialog.open(this.viewPopup, this.viewPopupConfig);

    // reset flags when popup closes
    this.visibleViewPopup.afterClosed().subscribe(() => {
      this.hasOpened = false;
      this.isProcessing = true;
    });

    setTimeout(() => (this.isProcessing = false), 0);
  }

  get displayName(): string {
    return this.docViewer?.docName?.length > 75
      ? this.docViewer.docName.substring(0, 75) + '...'
      : this.docViewer?.docName;
  }

  viewPopupConfig = {
    width: '100%',
    height: '90%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' }
  };

  downloadDocument() {
    const timestamp = Date.now();
    const formattedDate = new Intl.DateTimeFormat('en-US', {
      day: '2-digit', month: 'short', year: 'numeric'
    }).format(new Date(timestamp));

    const fileName = `OneQmsDocs_${formattedDate}_${this.docViewer.docName}.${this.docViewer.docExtension}`;
    const downloadURL = URL.createObjectURL(this.docViewer.blob);

    const link = document.createElement('a');
    link.href = downloadURL;
    link.download = fileName;
    link.click();

    URL.revokeObjectURL(downloadURL);
  }

  cancelViewPopup() {
    this.visibleViewPopup.close();
  }

  printDocument() {
    if (!this.message.isDocumentDownloader) {
      this.snackBar.open('Printing is not permitted.', 'Close', { duration: 3000 });
      return;
    }
    if (!this.webViewerComp?.wvInstance?.UI) {
      this.snackBar.open('Document is still loading. Please wait.', 'Close', { duration: 3000 });
      return;
    }
    try {
      this.webViewerComp.wvInstance.UI.print();
    } catch (err) {
      console.error('Print error:', err);
      this.snackBar.open('Failed to print document.','Close', { duration: 3000 });
    }
  }
  onUserActivity(): void {
    this.sessionTimeoutService.notifyActivity();
  }
}
